import React from 'react'
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from './Navbar'
import About from '../pages/About'
import Education from '../pages/Education'
import Projects from '../pages/Projects'
import Contact from '../pages/Contact'
import Cert from '../pages/Cert'
import Footer from './Footer';

function Home() {
  return (
    <Router>
      <div className="font-sans bg-gradient-to-tr overflow-x-hidden min-w-screen from-zinc-950 via-stone-900 to-neutral-950 flex min-h-screen flex-col items-center justify-between">
        <main className="max-[400px]:p-2.5 p-4 py-10 gap-6 w-full max-w-[95%] sm:max-w-[90%] md:max-w-[80%] lg:w-[55%]">
          <section className="w-full flex gap-4 justify-start mb-7 p-2">
            <div>
              <img
                src="https://avatars.githubusercontent.com/Amarjit-Khan"
                alt="avatar"
                className="w-12 h-12 rounded-full shadow-lg grayscale hover:grayscale-0 duration-300"
              />
            </div>
            <div className="flex flex-col gap-1 justify-center">
              <h3 className="mb-0 text-white">Amarjit</h3>
              <div className="mb-0 text-zinc-400 font-normal leading-none">
                Student • Dev • Cynophile
              </div>
            </div>
          </section>
          <Navbar />
          <div>
            <Routes>
              <Route path="/" element={<About />} />
              <Route path="/education" element={<Education />} />
              <Route path="/projects" element={<Projects />} />
              <Route path="/certificates" element={<Cert />} />
              <Route path="/contact" element={<Contact />} />
            </Routes>
          </div>
        </main>
        <Footer />
      </div>
    </Router>
  )
}

export default Home